import React from "react";
import { Blockquote } from "./Blockquote";
import { Text } from "@chakra-ui/react";

export function Disclaimer() {
  return (
    <Blockquote>
      <Text>
        The code blocks below use TypeScript by default. You can use the
        dropdown menu above each code block to switch to JavaScript.
      </Text>
      <br />
      <Text>
        If you&apos;re using JavaScript, use `.js` and `.jsx` file extensions
        wherever `.ts` and `.tsx` appear.
      </Text>
    </Blockquote>
  );
}
